import { Component } from './Component';
import { SelectionStore } from '../store/SelectionStore';
import { createLogger } from '../utils/logger';

const log = createLogger('GenerationCapSlider');

const MIN_GENERATIONS = 1;
const MAX_GENERATIONS = 12;

export class GenerationCapSlider extends Component {
  render(): HTMLElement {
    const { generationCap } = SelectionStore.getState();

    const el = document.createElement('div');
    el.className = 'generation-cap-slider';
    el.setAttribute('data-testid', 'generation-cap-slider');

    el.innerHTML = `
      <label for="gen-cap-range" class="gen-cap-label">
        Generations:&nbsp;<span class="gen-cap-value" data-testid="gen-cap-value">${generationCap}</span>
      </label>
      <input
        id="gen-cap-range"
        type="range"
        class="gen-cap-range"
        data-testid="gen-cap-range"
        min="${MIN_GENERATIONS}"
        max="${MAX_GENERATIONS}"
        step="1"
        value="${generationCap}"
        aria-label="Generation cap"
      />
    `;

    return el;
  }

  mount(parent: HTMLElement): void {
    super.mount(parent);
    this._wireEvents();
    this.track(SelectionStore.subscribe(() => this._sync()));
    log.info('GenerationCapSlider mounted');
  }

  // ── Private ────────────────────────────────────────────────────────────────

  private _wireEvents(): void {
    const rangeEl = this.el.querySelector<HTMLInputElement>('.gen-cap-range')!;
    rangeEl.addEventListener('input', () => {
      SelectionStore.setState({ generationCap: Number(rangeEl.value) });
    });
  }

  private _sync(): void {
    const { generationCap } = SelectionStore.getState();
    const rangeEl = this.el.querySelector<HTMLInputElement>('.gen-cap-range')!;
    rangeEl.value = String(generationCap);
    const valueEl = this.el.querySelector<HTMLSpanElement>('.gen-cap-value')!;
    valueEl.textContent = String(generationCap);
  }
}
